module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/covid_measures/1_fa14a7faeed4ee8e81566fa0e568a62e.png";